import React, { useEffect, useMemo, useState } from 'react';

const decodeEscapedUnicode = (value = '') =>
  value
    .replace(/\\u\{([0-9a-fA-F]{1,6})\}/g, (match, hex) => {
      const codePoint = Number.parseInt(hex, 16);
      return Number.isNaN(codePoint) ? match : String.fromCodePoint(codePoint);
    })
    .replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
      const codePoint = Number.parseInt(hex, 16);
      return Number.isNaN(codePoint) ? match : String.fromCharCode(codePoint);
    });

const wrapTablesForScroll = (html = '') =>
  html.replace(/<table\b/gi, '<div class="md-table-wrap"><table').replace(/<\/table>/gi, '</table></div>');

const ContentRenderer = ({ index, htmlContent, conversation_id, isLatestMessage, IsStreamApi }) => {
  const [imageUrls, setImageUrls] = useState([]);
  const [coversation, setConversation] = useState(null);
  const [isTyping, setIsTyping] = useState(isLatestMessage);
  const normalizedHtmlContent = useMemo(
    () => wrapTablesForScroll(decodeEscapedUnicode(htmlContent || '')),
    [htmlContent]
  );

  useEffect(() => {
    setIsTyping(false);
  }, [normalizedHtmlContent, isLatestMessage, IsStreamApi]);


  // Reset images when conversation_id changes
  useEffect(() => {
    if (conversation_id?.id !== coversation) {
      setImageUrls([]); // Reset image list
      setConversation(conversation_id?.id);
    }
  }, [conversation_id?.id]); // Run only when conversation_id.id changes

  useEffect(() => {
    // Function to handle anchor tag clicks
    const handleAnchorClick = (event) => {
      event.preventDefault();
      const url = event.target.href;
      window.open(url, '_blank');
    };

    // Get all anchor tags within the rendered HTML
    const anchors = document.querySelectorAll('.markDownSetting a');
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', handleAnchorClick);
    });

    // Search for all anchor tags with href attributes containing .png or .jpg
    const anchorTags = normalizedHtmlContent.match(/<a[^>]+href="([^">]+)"/g);

    if (anchorTags) {
      const urls = anchorTags
        .map((tag) => {
          const match = tag.match(/href="([^">]+)"/);
          return match ? match[1] : null;
        })
        .filter(Boolean)
        .filter((url) => url.endsWith('.png') || url.endsWith('.jpg'));

      setImageUrls(urls);
    }

    // Cleanup event listeners on component unmount
    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
    };
  }, [normalizedHtmlContent]);

  return (
    <div>
      {/* Render the content */}
      <div id={`id_${index}`} className="markDownSetting">
        {isTyping ? (
          <div className="whitespace-pre-wrap font-mono text-foreground">
            <span dangerouslySetInnerHTML={{ __html: normalizedHtmlContent }} />
            <span className="animate-pulse">|</span>
          </div>
        ) : (
          <div className='msg-resp' dangerouslySetInnerHTML={{ __html: normalizedHtmlContent }} />
        )}
      </div>

      {/* Render images found in the anchor tags */}
      {imageUrls.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          {imageUrls.map((url, idx) => (
            <img key={idx} src={url} alt={`Content Image ${idx}`} style={{ width: '200px', height: 'auto' }} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ContentRenderer;
